<template lang="pug">
  span(v-bind:class="colorClass")
    template(v-if="isZero") ±0
    template(v-else) {{asFilesize}}
</template>

<script>
import Filesize from 'filesize'

const colorClasses = {
  plus: 'text-danger',
  minus: 'text-success',
  zero: 'text-warning',
};

export default {
  props: {
    expectMinus: {
      type: Boolean,
      default: false,
    },
    value: Number,
  },
  computed: {
    isZero: function() {
      return this.value == 0;
    },
    colorClass: function() {
      if (this.expectMinus) {
        return this.value > 0 ? 'text-danger'
          : this.value < 0 ? 'text-success'
          : 'text-warning';
      } else {
        return 'text-success';
      }
    },
    asFilesize: function() {
      return Filesize(this.value);
    },
  },
}
</script>
